import { Box, Typography, useTheme } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

import Link from "../../../atoms/mui/Link";

import { analyticsTrack } from "../../../../helpers/analytics";

import { useScoutCardContext } from "../ScoutCardContext";

const ScoutNavigateCard = ({ label, href, description }) => {
  const { palette } = useTheme();
  const { surface } = useScoutCardContext();

  const handleClick = () =>
    analyticsTrack("scout_navigate_card_clicked", {
      surface: surface || null,
      href
    });

  return (
    <Link href={href} onClick={handleClick}>
      <Box
        p={2}
        style={{
          backgroundColor: palette.backgroundGray.light,
          border: `1px solid ${palette.primary.main}`,
          borderRadius: "8px",
          cursor: "pointer"
        }}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        gap={2}
      >
        <Box display="flex" flexDirection="column" gap={0.5}>
          <Typography variant="subtitle2" color="primary">
            {label}
          </Typography>
          {description && (
            <Typography variant="caption" color="textSecondary">
              {description}
            </Typography>
          )}
        </Box>
        <FontAwesomeIcon
          icon={faArrowRight}
          color={palette.primary.main}
          style={{ fontSize: 16 }}
        />
      </Box>
    </Link>
  );
};

export default ScoutNavigateCard;
